'use client';

import { motion, useReducedMotion } from 'framer-motion';
import { useTranslations } from 'next-intl';
import FadeInSection from '@/components/ui/FadeInSection';
import BlogPostCard, { postGridVariants } from '@/components/ui/BlogPostCard';
import { BLOG_POSTS } from '@/lib/blog';

export default function BlogSection() {
  const t = useTranslations('blog');
  const reduceMotion = useReducedMotion();

  return (
    <div className="mx-auto w-full max-w-6xl">
      <FadeInSection direction="right" distance={64}>
        <p className="text-label-caps uppercase tracking-widest text-primary">{t('eyebrow')}</p>
        <h1 className="mt-stack-md font-headline text-headline-lg font-bold tracking-[0.02em] text-on-surface">
          {t('headline')}
        </h1>
        <p className="mt-stack-md max-w-2xl text-body-md text-on-surface-variant md:text-body-lg">
          {t('subtitle')}
        </p>
      </FadeInSection>

      <motion.div
        className="mt-stack-lg grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3"
        variants={postGridVariants}
        initial={reduceMotion ? false : 'hidden'}
        whileInView="visible"
        viewport={{ once: true, margin: '-10% 0px' }}
      >
        {BLOG_POSTS.map((meta) => (
          <BlogPostCard key={meta.id} meta={meta} />
        ))}
      </motion.div>
    </div>
  );
}
